import cookieFactory from './index';

export default class UtmCookie {
  constructor() {
    this.params = new URLSearchParams(window.location.search);
    this.cookie = cookieFactory('utm_params');
  }

  get() {
    let utmParams = null;

    if (this.params.get('utm_campaign')) {
      utmParams = {
        utm_campaign: this.params.get('utm_campaign'),
        utm_source: this.params.get('utm_source'),
      };
      this.set();
    } else if (this.cookie.get()) {
      // some cookies have been corrupted in the past
      // if we can't parse it bin it.
      try {
        utmParams = JSON.parse(this.cookie.get());
      } catch (error) {
        this.cookie.remove();
      }
    }

    return utmParams;
  }

  set() {
    if (this.params.get('utm_campaign')) {
      this.cookie.set(JSON.stringify({
        utm_campaign: this.params.get('utm_campaign'),
        utm_source: this.params.get('utm_source'),
      }));
    };
  }

  remove() {
    if (this.cookie.get()) {
      this.cookie.remove();
    }
  }
};
